export const lenCheck = (
  value: string | number | null,
  minLen: number,
  maxLen: number,
  requiredMessage: string | null,
  tooShortMessage: string,
  tooLongMessage: string
) => {
  if (value === "" || value === null) {
    return requiredMessage;
  }
  const len = value.toString().length;
  if (len < minLen) {
    return tooShortMessage;
  }
  if (len > maxLen) {
    return tooLongMessage;
  }
  return null;
};

export const pipeValidators =
  <V, VS>(...validators: Array<(value: V, values?: VS) => React.ReactNode>) =>
  (value: V, values?: VS) => {
    for (const v of validators) {
      const error = v(value, values);
      if (error) {
        return error;
      }
    }

    return null;
  };

export const minLength = (min: number, error: React.ReactNode) => (value: unknown) => {
  if (typeof value !== "string" && typeof value !== "number") {
    return null;
  }

  const len = value.toString().length;
  if (len < min) {
    return error;
  }

  return null;
};

export const maxLength = (max: number, error: React.ReactNode) => (value: unknown) => {
  if (typeof value !== "string" && typeof value !== "number") {
    return null;
  }

  const len = value.toString().length;
  if (len > max) {
    return error;
  }

  return null;
};

export const minValue = (min: number, error: React.ReactNode) => (value: unknown) => {
  if (typeof value !== "number") {
    return null;
  }

  if (value < min) {
    return error;
  }

  return null;
};

export const maxValue = (max: number, error: React.ReactNode) => (value: unknown) => {
  if (typeof value !== "number") {
    return error;
  }

  if (value > max) {
    return error;
  }

  return null;
};
